import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useClients } from '../../hooks/useClients';
const LOGOS_PER_PAGE = 6;
const SWIPE_INTERVAL = 4000;
export function TrustStrip() {
  const {
    clients,
    loading
  } = useClients();
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(clients.length / LOGOS_PER_PAGE);
  // Auto-advance pages
  useEffect(() => {
    if (totalPages <= 1) return;
    const timer = setInterval(() => {
      setPage(prev => (prev + 1) % totalPages);
    }, SWIPE_INTERVAL);
    return () => clearInterval(timer);
  }, [totalPages]);
  if (loading || clients.length === 0) {
    return null;
  }
  const currentLogos = clients.slice(page * LOGOS_PER_PAGE, page * LOGOS_PER_PAGE + LOGOS_PER_PAGE);
  return <section className="bg-[#F8F8F6]" data-id="element-682">
      <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-683">
        <div className="border-t border-gray-200" data-id="element-684" />

        <div className="py-16 flex flex-col lg:flex-row gap-10 lg:gap-0 items-start lg:items-center justify-between" data-id="element-685">
          {/* Far left: Text */}
          <div className="lg:max-w-[280px] shrink-0" data-id="element-686">
            <p className="text-gray-600 text-base leading-relaxed" data-id="element-687">
              We've worked with over{' '}
              <span className="font-bold text-[#0C0C0C]" data-id="element-688">
                {clients.length}+
              </span>{' '}
              companies including
            </p>

            {/* Page dots */}
            {totalPages > 1 && <div className="flex items-center gap-1.5 mt-5" data-id="element-689">
                {Array.from({
              length: totalPages
            }).map((_, i) => <button key={i} onClick={() => setPage(i)} className={`h-1.5 rounded-full transition-all duration-300 ${i === page ? 'w-5 bg-[#00316B]' : 'w-1.5 bg-gray-300 hover:bg-gray-400'}`} aria-label={`Page ${i + 1}`} data-id="element-690" />)}
              </div>}
          </div>

          {/* Far right: Logo grid with swipe */}
          <div className="relative w-full lg:w-auto lg:max-w-[700px] overflow-hidden" style={{
          minHeight: 120
        }} data-id="element-691">
            <AnimatePresence mode="wait" data-id="element-692">
              <motion.div key={page} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="grid grid-cols-3 gap-x-6 sm:gap-x-14 gap-y-10 items-center" data-id="element-693">
                {currentLogos.map(client => <div key={client.id} className="flex items-center justify-center" data-id="element-694">
                    <img src={client.logo} alt={client.name} className="h-8 lg:h-[40px] w-auto max-w-[100px] sm:max-w-[200px] object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300" draggable={false} data-id="element-695" />
                  </div>)}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}